module.exports = __webpack_public_path__ + "img/uzima_ug.fb008a98.png";